import { createTheme } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';

const theme = createTheme({
    overrides: {
        MUIRichTextEditor: {
            root: {
                minHeight: '300px',
                width: '100%',
                border: '1px solid #eeeeee',
                padding: '12px',
                borderRadius:'8px',
            },
            editor: {
                height: '100%',
            },
        },
        MuiButton: {
            root: {
                backgroundColor: '#478589',
                borderRadius: 3,
                color: 'green',
            },
        },
        MuiStepIcon: {
            root: {
                color: '#EF9761',
                width: '2em',
                height: '2em',
                marginRight: 10,
                marginBottom: 10,
                marginTop: 10,
                '&$completed': {
                    color: '#EF9761',
                },
                '&$active': {
                    color: '#EF9761',
                },
            },
            text: {
                fontSize: 14,
                fontWeight: 900,
            },
            active: {},
            completed: {},
        },
        MuiInputBase:
        {
            input:
            {
                fontSize: 16,
                color: '#000000',
            },
        },
        MuiInputLabel:
        {
            root:
            {
                fontSize: 16,
                color: '#000000',
                transform: 'initial',
            },
            filled:
            {
                transform: 'translate(0, 24px) scale(1)',
            },
            shrink:
            {
                transform: 'translate(0, 8px) scale(0.75) !important',
            },
        },
        MuiFormLabel:
        {
            root:
            {
                '&$focused': {
                    color: '#000000',
                },
                '&$error': {
                    color: '#000000',
                },
            },
        },
        MuiFilledInput:
        {
            root:
            {
                backgroundColor: 'transparent',
                '&$focused': { // increase the specificity for the pseudo class
                    backgroundColor: 'transparent',
                },
                '&$disabled': {
                    opacity: '0.4',
                },
            },
            input:
            {
                background: 'transparent',  // '#F1F1F1'
                paddingLeft: '0',
            },
            underline:
            {
                '&&&&:before': {
                    borderBottom: '1px solid #070606',
                },
                '&&&&:after': {
                    border: '0',
                },
            },
        },
        MuiInput:
        {
            root:
            {
                '&$disabled': {
                    opacity: '0.4',
                },
            },
            input:
            {
                paddingLeft: '0',
            },
            underline:
            {
                '&&&&:before': {
                    borderBottom: '1px solid #070606',
                },
                '&&&&:after': {
                    border: '0',
                },
            },
        },
        MuiStepContent: {
            root: {
                borderLeft: '4px dotted #F6C4A5',
                marginLeft: 26,
            },
        },
        MuiCollapse: {
            container: {
                marginLeft: 26,
            },
        },
        MuiStepConnector: {
            lineVertical: {
                display: 'none',
            },
        },
        MuiAccordionDetails:{
            root: {
                '& p': {
                    marginBottom: '0 !important',
                    paddingBottom: '0 !important',
                },
            },
        },
        MuiFormHelperText: {
            root: {
                '&$contained': {
                    marginLeft: '0px',
                    color: '#000000',
                },

                '&$error': {
	                color: '#e40000 !important',
                    marginLeft: '0px',
                },
            },
        },
        breakpoints: {
            values: {
                mobilesmall: 640,
                mobile: 1024,
                small: 1280,
                tablet: 640,
                tablethori: 1024,
                desktop: 1280,
            },
        },
    },
    typography: {
        fontSize: 16,
    },
    palette: {
        primary: {
            light: '#67CFD6',
            main: '#478589',
            dark: '#3A6B6E',
        },
        secondary: {
            main: '#EF9761',
        },
        error: {
            main: red.A400,
        },
        background: {
            default: '#FFFFFF',
            white: '#FFFFFF',
            grey: '#EEEEEE',
            button: '#D6D6D6',
            buttonLight: '#315B5E',
        },
        taenk: {
            primary: '#3FAE38',
        },
        text: {
            primary: '#000000',
            h2: '#505050',
            link: '#949494',
            white: '#FFFFFF',
        },
        icon: {
            primary: '#949494',
        },
    },
});

export default theme;
